import axios from "axios";
import { roundNumber } from "@helpers/general";
import DISCOUNT_TYPES from "@constants/DiscountTypes";

const shippingFees = require("@context/shippingFees.json");

export function getFreeShippingThresholdFromCountry(country) {
  try {
    const shipping = shippingFees[country.CountryName];
    return Number(shipping.freeShippingCartValue);
  } catch (error) {
    return null;
  }
}

export function getShippingFeeFromCountry(country) {
  try {
    const shipping = shippingFees[country.CountryName];
    return Number(shipping.shippingFree);
  } catch (error) {
    return null;
  }
}

export function isStandardShipping(country) {
  try {
    return shippingFees[country.CountryName]?.isStandardShipping ?? false;
  } catch (error) {
    return false;
  }
}

export function parsePrices(prices) {
  const { full_price, final_price, price, ...rest } = prices;
  return {
    full_price: Number.parseFloat(full_price ?? final_price),
    final_price: Number.parseFloat(final_price),
    price: Number(price),
    ...rest,
  };
}

export function calculateBasePrices(compareAtPrice, price, discounts) {
  let full_price = null;
  let final_price = null;
  let discount_given = null;

  if (
    !!discounts &&
    discounts.length === 1 &&
    discounts?.[0] !== "empty" &&
    discounts?.[0]?.type === DISCOUNT_TYPES.SITEWIDE_PERCENT
  ) {
    full_price = compareAtPrice && compareAtPrice > price ? compareAtPrice : price;
    final_price = roundNumber(price * ((100 - discounts[0].value) / 100));

    const discount_given = roundNumber(
      roundNumber(((full_price - final_price) / full_price) * 100)
    );

    return {
      full_price,
      final_price,
      discount_given,
      currency: "$",
    };
  }

  final_price = price;
  full_price = price;
  if (compareAtPrice && compareAtPrice > price) {
    full_price = compareAtPrice;
    discount_given = roundNumber(roundNumber(((full_price - final_price) / full_price) * 100));
  }
  return {
    full_price,
    final_price,
    discount_given,
    currency: "$",
  };
}

export function getLocalizedPricesWithDiscount({
  compareAtPrice,
  price,
  discounts,
  shouldUseDiscount = true,
}) {
  const discountToUse = shouldUseDiscount ? discounts : null;
  const prices = parsePrices(calculateBasePrices(compareAtPrice, price, discountToUse));
  return {
    price_before_sitewide_discount: Number(price),
    ...prices,
  };
}

export async function convertFromUSD(amounts, targetCountryCode) {
  if (amounts.length === 0) {
    return {
      amounts,
      currency: "USD",
    };
  }
  try {
    const res = await axios.get(
      `/.netlify/functions/convert-currencies?countryCode=${targetCountryCode}&fromUSD=true&amounts=${amounts}`
    );
    return res.data;
  } catch (err) {
    console.error("Error converting currency:", err);
  }
  return {
    amounts,
    currency: "USD",
  };
}
